import { matchRoutes, useLocation } from 'react-router-dom';
import { FC, memo, useEffect } from 'react';

import { SirenProvider } from '@sirenapp/react-inbox';

import MainLayout from '@layouts/main-layout/MainLayout';
import { getLocalStorageItem } from '@utils/storage';
import { PageNames, pathList } from '@core/analytics/events';
import { trackPageView } from '@core/analytics';

import ChatTop from '@features/chat/components/ChatTop';

const MainLayoutWrapper: FC<any> = () => {
  const { pathname } = useLocation();
  const config = {
    recipientId: getLocalStorageItem('siren_inapp_recipientId') || '',
    userToken: getLocalStorageItem('siren_inapp_token') || ''
  };

  useEffect(() => {
    const userMatch = matchRoutes(pathList, pathname);

    if (userMatch && userMatch?.length) {
      trackPageView(PageNames[userMatch[0].route.path]);
    }
  }, [pathname]);
  return (
    <SirenProvider config={config}>
      <MainLayout />
      <ChatTop />
    </SirenProvider>
  );
};

export default memo(MainLayoutWrapper);
